<template>
  <div>
    <UiPageTitle :title="title" hide-arrow>
      <DisableAppsSwitcher slot="right" class="switcher-wrapper" />

      <PresetsControls slot="right" class="switcher-wrapper" />
    </UiPageTitle>
  </div>
</template>

<script>
import UiPageTitle from '@/components/UiPageTitle.vue'

import { currecyFormat } from '@/mixins/currency'

import { ApplicationsService } from '@/services/applications.service'

export default {
  components: {
    UiPageTitle,
    DisableAppsSwitcher: () => import('./DisableAppsSwitcher.vue'),
    PresetsControls: () => import('./presets/controls.vue'),
  },
  data() {
    return {
      balance: 0,
    }
  },
  computed: {
    /**
     * Build page title. Template: Аккаунты — %balance%
     * If balance equals zero, then return just string `Аккаунты`.
     */
    title() {
      const title = 'Аккаунты'

      if (!this.balance) return title

      return `${title} — ${this.balance}`.trim()
    },
  },
  mounted() {
    this.getSummaryBalance()
  },
  methods: {
    /**
     * Send request to backend for get current total apps balance.
     * Then set this.balance by reseponse.
     *
     * @returns {Void} Set this.balance value after response.
     * */
    async getSummaryBalance() {
      try {
        const { data } = await ApplicationsService.getBalance()

        this.balance = currecyFormat(data.balance, { style: 'currency' })
      } catch (error) {
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
        this.error = error.message
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.switcher-wrapper {
  margin: 0 0 0 rem(12px);
}
</style>
